import { Map } from "immutable";
import { combineReducers } from "redux";
import { FETCH_TASKS_SUCCESS, FLUSH_ALL_TASKS_FROM_STORE } from "~/store/action_types";

const initialState = Map({
  currentPage: 1,
  itemsPerPage: 0,
  totalItems: 0,
});

const pagination = (state = initialState, action) => {
  const { responseHeaders = {} } = action;

  if (Object.prototype.hasOwnProperty.call(responseHeaders, "x-angie-paginationcurrentpage")) {
    state = state.set(`currentPage`, parseInt(responseHeaders[`x-angie-paginationcurrentpage`]));
  }

  if (Object.prototype.hasOwnProperty.call(responseHeaders, "x-angie-paginationitemsperpage")) {
    state = state.set(`itemsPerPage`, parseInt(responseHeaders[`x-angie-paginationitemsperpage`]));
  }

  if (Object.prototype.hasOwnProperty.call(responseHeaders, "x-angie-paginationtotalitems")) {
    state = state.set(`totalItems`, parseInt(responseHeaders[`x-angie-paginationtotalitems`]));
  }

  return state;
};

const projectTasks = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_TASKS_SUCCESS:
      return state.set(`${action.projectId}`, pagination(state.get(`${action.projectId}`), action));
    case FLUSH_ALL_TASKS_FROM_STORE:
      return Map();
    default:
      return state;
  }
};

export default combineReducers({
  projectTasks,
});
